// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__g5y_B","copyright":"Footer_copyright__RlJgA","fade_in":"Footer_fade_in__8skR7"};